export enum FiPersonalNotificationClickAction {
    GoToState = 0,
    OpenChatConversation = 1,
}
